import React from 'react';
import ReactDOM from 'react-dom/client';
// Bootstrap und Schriften aus dem Bundle statt von jsDelivr/Google Fonts: keine fremden Origins
// im kritischen Pfad, gleiche Kaskade (Bootstrap vor den eigenen Stilen). Schrift wie auf
// kalakutok.com: Spline Sans Mono, JetBrains Mono als Rueckfall (z. B. fuer Kyrillisch).
import 'bootstrap/dist/css/bootstrap.min.css';
import '@fontsource/spline-sans-mono/400.css';
import '@fontsource/spline-sans-mono/500.css';
import '@fontsource/spline-sans-mono/600.css';
import '@fontsource/spline-sans-mono/700.css';
import '@fontsource/jetbrains-mono/400.css';
import '@fontsource/jetbrains-mono/500.css';
import './index.css';
import App from './App';
import { SpracheProvider } from './sprache';
import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <SpracheProvider>
      <App />
    </SpracheProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
